import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_ZONES } from '../get-zones';
import { updateZoneAPI } from './api';

export function useUpdateZone() {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const mutation = useMutation(({ id, zone }) => updateZoneAPI(id, zone), {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_ZONES, tenantId]);
      openModal({
        modalType: 'NotificationModal',
        modalProps: { type: 'success', description: 'Zone updated' },
      });
    },
    onError: () => {
      openModal({
        modalType: 'NotificationModal',
        modalProps: { type: 'error', description: 'genericErrorMessage' },
      });
    },
  });

  return {
    ...mutation,
  };
}

